// Colocated strings for BaseGanttChart (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these nine keys resolve here, and the card title arrives
// already translated as a prop.
//
// `loadMore` (AM_ABSORPTION_PLAN D6, the opt-in `childPageSize`'s "load more" row) is standalone
// asset-management's `loadMore` ("Load more...") with nine new translations.
//
// `loading` carries BaseTimeSeriesChart's translations (`@rdrive/plugin-chart-time-series`) —
// issue-analysis's IssueDueByGantt.vue asked the root composer for a `loading` key no bundle had,
// so its overlay read the raw "loading...". The other seven (`selectStatuses`, `expandAll`,
// `collapseAll`, `zoomToFit` and the three column headers `name`/`startDate`/`dueDate`) were
// English literals in that SFC, so they ship as ENGLISH in all 10 files on purpose — the
// `loaded` policy: untranslated (translation debt), but resolving locally, so no warning and no
// chance of a blank. `vi` (the 11th locale, 2026-10-28) shipped with all nine translated.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
